import { RouteGuardDefinition } from './routeGuardDefinition';
import { AuthenticatedUserGuard } from './authenticatedUserGuard';

const guards: RouteGuardDefinition[] = [
  new AuthenticatedUserGuard(),
];

export default guards;
